import { ComponentFactoryResolver, ElementRef, Injector, NgZone, OnDestroy, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { PopupService } from '@ng-bootstrap/ng-bootstrap/util/popup';
import { positionElements } from '@ng-bootstrap/ng-bootstrap/util/positioning';
var nextId = 0;
var defaultDurationInMs = 3000;
var defaultPlacement = 'auto';
var NotificationWindowComponent = /** @class */ (function () {
    function NotificationWindowComponent(element, renderer, ngZone) {
        this.element = element;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.popover = true;
        this.notification = true;
        this.role = 'tooltip';
    }
    NotificationWindowComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.refreshPosition();
        this.zoneSubscription = this.ngZone.onStable.subscribe(function () { return _this.refreshPosition(); });
    };
    Object.defineProperty(NotificationWindowComponent.prototype, "success", {
        get: function () {
            return this.type === 'success';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationWindowComponent.prototype, "failure", {
        get: function () {
            return this.type === 'failure';
        },
        enumerable: true,
        configurable: true
    });
    NotificationWindowComponent.prototype.applyPlacement = function (placement) {
        // remove the current placement classes
        this.renderer.removeClass(this.element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this.renderer.removeClass(this.element.nativeElement, 'bs-popover-' + this.placement.toString());
        // set the new placement classes
        this.placement = placement;
        // apply the new placement
        this.renderer.addClass(this.element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this.renderer.addClass(this.element.nativeElement, 'bs-popover-' + this.placement.toString());
    };
    NotificationWindowComponent.prototype.refreshPosition = function () {
        var position = positionElements(this.location.nativeElement, this.element.nativeElement, this.placement, true);
        this.applyPlacement(position);
    };
    NotificationWindowComponent.prototype.ngOnDestroy = function () {
        if (this.zoneSubscription) {
            this.zoneSubscription.unsubscribe();
        }
    };
    return NotificationWindowComponent;
}());
export { NotificationWindowComponent };
var NotificationDirective = /** @class */ (function () {
    function NotificationDirective(location, renderer, injector, componentFactoryResolver) {
        this.location = location;
        this.renderer = renderer;
        this.injector = injector;
        this.componentFactoryResolver = componentFactoryResolver;
        this.ngbPopoverWindowId = "app-notification-" + nextId++;
        this.popupService = null;
    }
    NotificationDirective.prototype.showSuccess = function (msg, durationInMs, placement) {
        if (durationInMs === void 0) { durationInMs = defaultDurationInMs; }
        if (placement === void 0) { placement = defaultPlacement; }
        this.show('success', msg, durationInMs, placement);
    };
    NotificationDirective.prototype.showFailure = function (msg, durationInMs, placement) {
        if (durationInMs === void 0) { durationInMs = defaultDurationInMs; }
        if (placement === void 0) { placement = defaultPlacement; }
        this.show('failure', msg, durationInMs, placement);
    };
    NotificationDirective.prototype.isOpen = function () {
        return this.popupService !== null && this.timeoutHandle !== null;
    };
    NotificationDirective.prototype.show = function (type, msg, durationInMs, placement) {
        var _this = this;
        if (this.isOpen()) {
            this.close(true);
        }
        this.popupService = new PopupService(NotificationWindowComponent, this.injector, this.location, this.renderer, this.componentFactoryResolver);
        var windowRef = this.popupService.open(msg, {});
        windowRef.instance.id = this.ngbPopoverWindowId;
        windowRef.instance.location = this.location.element;
        windowRef.instance.placement = placement;
        windowRef.instance.type = type;
        this.renderer.setAttribute(this.location.element.nativeElement, 'aria-describedby', this.ngbPopoverWindowId);
        window.document.querySelector('body').appendChild(windowRef.location.nativeElement);
        this.timeoutHandle = window.setTimeout(function () { return _this.close(false); }, durationInMs);
    };
    NotificationDirective.prototype.close = function (clearTimeout) {
        this.renderer.removeAttribute(this.location.element.nativeElement, 'aria-describedby');
        if (this.popupService === null || this.timeoutHandle === null) {
            throw new Error('Cannot close since notification is not shown');
        }
        if (clearTimeout) {
            window.clearTimeout(this.timeoutHandle);
        }
        this.popupService.close();
        this.popupService = null;
        this.timeoutHandle = null;
    };
    return NotificationDirective;
}());
export { NotificationDirective };
